import { getPlayerTypeBadge } from '../components/PlayerTypeBadge';

export function getTypeBalance(players) {
  const counts = { T: 0, P: 0, S: 0, none: 0 };
  for (const player of players) {
    if (!player) continue;
    const type = getPlayerTypeBadge(player);
    if (type && counts[type] !== undefined) counts[type] += 1;
    else counts.none += 1;
  }
  return counts;
}

export function getAverageAge(players) {
  const ages = players.filter((p) => p && Number(p.age) > 0).map((p) => Number(p.age));
  if (!ages.length) return null;
  return Math.round((ages.reduce((a, b) => a + b, 0) / ages.length) * 10) / 10;
}

export function getAverageOv(players) {
  const ovs = players.filter((p) => p && Number(p.OV) > 0).map((p) => Number(p.OV));
  if (!ovs.length) return null;
  return Math.round((ovs.reduce((a, b) => a + b, 0) / ovs.length) * 10) / 10;
}

/**
 * Chemistry for a forward/defense line based on T/P/S mix.
 * Returns { label, tone } or null if fewer than 2 typed players.
 */
export function getLineChemistry(linePlayers) {
  const typed = linePlayers
    .filter(Boolean)
    .map((p) => getPlayerTypeBadge(p))
    .filter(Boolean);

  if (typed.length < 2) return null;

  const unique = new Set(typed);
  const allSame = unique.size === 1;

  if (typed.length >= 3 && unique.has('T') && unique.has('P') && unique.has('S')) {
    return { label: 'Balanced T/P/S', tone: 'good' };
  }

  if (allSame) {
    const type = typed[0];
    const names = { T: 'Transport', P: 'Playmaker', S: 'Scorer' };
    return { label: `All ${names[type]}`, tone: 'warn' };
  }

  if (unique.size === 2) {
    return { label: `${[...unique].join('+')} mix`, tone: 'ok' };
  }

  return { label: 'Mixed', tone: 'ok' };
}

export function summarizeLineup(forwards, defensemen, lineupGoalies) {
  const skaters = [
    ...forwards.flatMap((line) => Object.values(line).filter(Boolean)),
    ...defensemen.flatMap((line) => Object.values(line).filter(Boolean)),
  ];
  const goalies = lineupGoalies.filter(Boolean);
  const all = [...skaters, ...goalies];

  return {
    skaterCount: skaters.length,
    goalieCount: goalies.length,
    totalCount: all.length,
    typeBalance: getTypeBalance(skaters),
    avgAge: getAverageAge(all),
    avgOv: getAverageOv(skaters),
    forwardChemistries: forwards.map((line) =>
      getLineChemistry(Object.values(line).filter(Boolean))
    ),
    defenseChemistries: defensemen.map((line) =>
      getLineChemistry(Object.values(line).filter(Boolean))
    ),
  };
}
